<template>
  <form @submit.prevent="onSave">
    <div class="vx-col w-full mb-3">
      <elsa-v-select
        :options="buildings"
        v-model="data.building"
        label="address"
        :reduce="item => item.id"
        :clearable="false"
        htmlLabel="Дом"
        styleType="largeLabel"
      />
    </div>

    <div class="vx-col w-full mb-3">
      <elsa-v-select
        :options="apartments"
        v-model="data.apartment"
        label="account_number"
        :reduce="item => item.id"
        :clearable="false"
        htmlLabel="Лицевой счет"
        styleType="largeLabel"
        :disabled="!data.building"
        :loading="apartmentsLoading"
      />
    </div>

    <div class="text-center">
      <vs-button
        id="PaymentEditAccountModalButton"
        class="vs-con-loading__container"
        :disabled="loading"
        button="submit"
        type="filled"
        color="primary"
      >
        Сохранить
      </vs-button>
    </div>
  </form>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";
import modal           from "@/mixins/modalContext";

export default {
  name:   "PaymentEditAccountModal",
  props:  ['payment'],
  mixins: [notifyHttpError, modal],
  data() {
    return {
      loading:           false,
      data:              {
        building:  this.payment.buildings_id,
        apartment: null,
      },
      apartmentsLoading: false,
      apartments:        [],
    };
  },
  computed: {
    buildings() {
      return this.$store.getters['appUser/houses'];
    },
  },
  methods:  {
    updateLoading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#PaymentEditAccountModalButton',
          scale:     .5,
        });

      } else {
        this.$vs.loading.close('#PaymentEditAccountModalButton > .con-vs-loading');
      }
    },

    loadApartments() {
      const { building } = this.data;
      if (!building) {
        this.apartments = [];
        return Promise.resolve();
      }
      this.apartmentsLoading = true;
      return this.$http.get(`all_aparts`, { params: { buildings_id: building } }).then(
        ( { data: apartments } ) => {
          this.apartments = apartments;
          if (this.data.apartment) {

          }
        },
        this.notifyHttpError,
      ).finally(() => {
        this.apartmentsLoading = false;
      });
    },
    onSave() {
      if (this.loading) return;
      const { apartment } = this.data;
      if (!apartment) return;

      this.loading = true;
      this.$http.put(`/support/invoice/${this.payment.id}/apartment/${apartment}`, null, { params: { buildings_id: this.payment.buildings_id } }).then(
        () => this.modalResolve(),
        this.notifyHttpError,
      ).finally(() => this.loading = false);
    },
  },
  mounted() {
    this.loadApartments().then(() => {
      const { account_number } = this.payment;
      if (!account_number) return;
      const apartment = this.apartments.find(a => a.account_number === account_number);
      if (apartment) this.data.apartment = apartment.id;
    });
  },
  watch: {
    'data.building'() {
      this.data.apartment = null;
      this.loadApartments();
    },
    loading() {
      this.updateLoading();
    },
  },
};
</script>

<style scoped>

</style>
